import { globalState } from '../app/global-state';
import { ModalUtils } from './../components/modal/modal-utils';
import HistoryExtended from './history-extended';

export const initHistory = () => {
	if (!globalState.windowExists) {
		return;
	}

	const randomString = (length: number): string => {
		let result = '';
		const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
		for (let i = length; i > 0; --i) {
			result += chars[Math.floor(Math.random() * chars.length)];
		}

		return result;
	};

	const initializer = {
		intializeModalListener() {
			if (globalState.__historyPowerduckInitialized == true) {
				return;
			}

			globalState.__historyPowerduckInitialized = true;
			$(document).on(
				'show.bs.modal',
				'.modal',
				function (this: any) {
					const elem = this as HTMLElement;
					if (elem.getAttribute('data-preventhistory') == 'true') {
						return;
					}

					const modalId = randomString(16);
					elem.setAttribute('data-history-uuid', modalId);
					HistoryExtended.pushState(
						{ modalId },
						null,
						null,
					);
				},
			);

			$(document).on('fdd-show', (e: any, elem: HTMLElement) => {
				if (elem.getAttribute('data-preventhistory') == 'true') {
					return;
				}

				const fddId = randomString(16);
				elem.setAttribute('data-history-uuid', fddId);
				HistoryExtended.pushState(
					{ fddId },
					null,
					null,
				);
			});

			$(document).on(
				'hide.bs.modal',
				'.modal',
				function (this: any, e) {
					const elem = this as HTMLElement;
					if (elem.getAttribute('data-preventhistory') == 'true') {
						return;
					}

					const backButtonTriggered = elem.getAttribute('data-history-bbtrigger');
					elem.removeAttribute('data-history-bbtrigger');

					if (backButtonTriggered != 'true') {
						const isHandled = (e as any)._isNavHandled;
						if (isHandled != true) {
							(e as any)._isNavHandled = true;

							if (!HistoryExtended.nextBackWillNavigateAway()) {
								HistoryExtended.back({ silent: true });
							}
						}
					}
				},
			);

			$(document).on('fdd-hide', (e: any, elem: HTMLElement) => {
				if (elem.getAttribute('data-preventhistory') == 'true') {
					return;
				}

				const backButtonTriggered = elem.getAttribute('data-history-bbtrigger');
				elem.removeAttribute('data-history-bbtrigger');

				if (backButtonTriggered != 'true') {
					const isHandled = (e as any)._isNavHandled;
					if (isHandled != true) {
						(e as any)._isNavHandled = true;
						HistoryExtended.back({ silent: true });
					}
				}
			});

			HistoryExtended.addPopstateListener((detail) => {
				if (detail == null) {
					return;
				}

				if (detail.direction == 'back') {
					const stateFrom = detail.from;
					if (stateFrom == null) {
						return;
					}

					const getHistoryHandledItem = (uuid: string) => {
						const $item = $(`[data-history-uuid='${uuid}']`);
						$item.attr('data-history-bbtrigger', 'true');
						return $item;
					};

					const modalId = stateFrom.modalId;
					if (modalId != null && modalId.length > 0) {
						const $modal = getHistoryHandledItem(modalId);
						ModalUtils.hideModal($modal);
					}

					const fddId = stateFrom.fddId;
					if (fddId != null && fddId.length > 0) {
						getHistoryHandledItem(fddId);
						$('#btn_fdd_FddCancel').trigger('click');
					}
				}
			});
		},
		initBackdropFix() {
			if (globalState.__backdropFixInitialized == true) {
				return;
			}

			globalState.__backdropFixInitialized = true;
			$(document).on(
				'show.bs.modal',
				'.modal',
				function (this: any) {
					const $this = $(this);
					let highestZ = 0;

					$('.modal:visible').each(function (this: HTMLElement) {
						const zi = this.style.zIndex;
						if (zi != null && zi.length > 0) {
							const numZi = Number(zi);
							if (numZi > highestZ && numZi > 1049) {
								highestZ = numZi;
							}
						}
					});

					if (highestZ < 1049) {
						highestZ = 1049;
					}

					const zIndex = highestZ + 2;
					$this.css('z-index', zIndex);
					setTimeout(() => {
						$('.modal-backdrop')
							.not('.modal-stack')
							.css('z-index', zIndex - 1)
							.addClass('modal-stack');
					}, 0);
				},
			);

			$(document).on(
				'hidden.bs.modal',
				'.modal',
				function (this: any) {
					$(this).css('z-index', '');
				},
			);
		},
	};

	initializer.intializeModalListener();
	initializer.initBackdropFix();
};
